export interface ContentSetData{
    myID:number;
	title:string;
	imsList:string[];
	txtsList:string[];
    options:{optID:string,optVal:number}[];
    createdAt:string;
}

export interface FinderState{
	searchText:string;
	itemsMatched:string[][];
	categoriesMatched:string[];
	textsMatched:string[];
}

export enum ContentSetActions{
    View='VIEW',
    Open='OPEN',
    Delete='DELETE',
    Undo='UNDO',
    Save='SAVE',
    Discard='DISCARD'
}

export enum ContentTitleError{
	None='NONE',
	Short='SHORT',
	Already='ALREADY'
}

export enum ContentStatus{
    Default='DEFAULT',
    GetList='GETLIST',
    GetListError='GETLISTERROR',
    GetSet='GETSET',
    GetSetError='GETSETERROR',
    SaveSet='SAVESET',
    SaveSetError='SAVESETERROR',
    DeleteSet='DELETESET',
    DeleteSetError='DELETESETERROR'
}
